import { Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import Home from './pages/Home';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import SEO from './components/SEO';
import StructuredData from './components/StructuredData';
import Analytics from './components/Analytics';
import ScrollToTop from './components/ScrollToTop';

function App() {
  const location = useLocation();

  return (
    <div className="App">
      {/* Scroll to top on route change */}
      <ScrollToTop />
      
      {/* Analytics tracking */}
      <Analytics 
        googleAnalyticsId="G-XXXXXXXXXX" // Replace with your actual GA4 ID
        googleSearchConsoleId="your-search-console-verification-id" // Replace with your actual verification ID
      />
      
      {/* Global SEO and Structured Data */}
      <StructuredData type="organization" />
      <StructuredData type="localbusiness" />
      <StructuredData type="service" />
      
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
      </Routes>
    </div>
  );
}

export default App;
